<div class="html-container">
  <span class="search-highlight" [innerHTML]="value || (showPlaceholderIfEmpty ? '-' : '') | iconReplace"></span>
</div>
